import { render, staticRenderFns } from "./track_witness.vue?vue&type=template&id=0d31ef8a&scoped=true"
import script from "./track_witness.vue?vue&type=script&lang=js"
export * from "./track_witness.vue?vue&type=script&lang=js"
import style0 from "./track_witness.vue?vue&type=style&index=0&id=0d31ef8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d31ef8a",
  null
  
)

export default component.exports